import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const TrainingWrapper = (): ReactElement => <Outlet />;

export default TrainingWrapper;
